import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18n
  // Подключение бэкенда i18next
  .use(Backend)
  // Автоматическое определение языка
  .use(LanguageDetector)
  // модуль инициализации
  .use (initReactI18next)
  .init({
    // Стандартный язык
    fallbackLng: 'en',
    debug: true,
    // Поддерживаемые языки
    supportedLngs: ['en', 'de', 'it', 'es', 'ch', 'po', 'fr'],
    // Распознавание и кэширование языковых кук
    detection: {
      order: ['queryString', 'cookie'],
      // cache: ['cookie']
    },
    interpolation: {
      escapeValue: false
    },
    backend: {
      // Cache-busting: append a build-time token so a new deploy invalidates the
      // browser cache for translation files. Within one build the token is constant,
      // so files are still cached normally (no per-request refetch).
      loadPath: `/locales/{{lng}}/translation.json?v=${process.env.REACT_APP_BUILD_VERSION || 'dev'}`
    }
  })

export default i18n;
